import React, {
  Fragment,
  lazy,
  memo,
  Suspense,
  useEffect,
  useState,
  useCallback,
} from "react";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import Box from "@material-ui/core/Box";
import Skeleton from "@material-ui/lab/Skeleton";
import { isMobileOnly, isTablet, isMobile } from "react-device-detect";
import HeaderSearch from "./HeaderSearch";
import NavigationMenu from "./NavigationMenu";
import CartIcon from "./CartIcon";
import UserMenu from "./UserMenu";
import { useHistory } from "react-router";
import IconButton from "@material-ui/core/IconButton";
import Button from "@material-ui/core/Button";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import SearchIcon from "@material-ui/icons/Search";
import SwipeableDrawer from "@material-ui/core/SwipeableDrawer";
import { makeStyles } from "@material-ui/core/styles";
import MenuIcon from "@material-ui/icons/Menu";
import LocationOn from "@material-ui/icons/LocationOn";
import UseFetchSellerStore from "../../Services/UseFetchSellerStore";
import BranchAddress from "./BranchAddress";
import { Close } from "@material-ui/icons";
import { Typography } from "@material-ui/core";
const useStyles = makeStyles((theme) => ({
  searchDrawer: {
    "& .MuiDrawer-paper": {
      width: "100%",
    },
  },
}));
const HeaderLogo = lazy(() => import("./HeaderLogo"));
const Header = ({ HeaderData, isLoading, setShowHeader }) => {
  const classes = useStyles();
  const history = useHistory();
  const { data, isLoading: StoreLoading } = UseFetchSellerStore();
  const { push } = history;
  const [openMenu, setOpenMenu] = useState(false);
  const [openMobileSearch, setOpenMobileSearch] = useState(false);
  const [OpenBranchNav, setOpenBranchNav] = useState(false);
  const toggleDrawer = useCallback((event, item) => {
    if (
      event &&
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }
    if (item === "search") {
      setOpenMobileSearch(true);
    }
    if (item === "menu") {
      setOpenMenu(true);
    }
  }, []);
  const [pathname, setPathname] = useState(
    history.location && history.location.pathname
  );
  useEffect(() => {
    history.listen((location, action) => {
      setPathname(location.pathname);
    });
  }, [history, pathname]);
  const HandleGoBack = () => {
    if (history.length > 2) {
      history.goBack();
    } else {
      push("/");
    }
  };
  const CloseSearch = useCallback(() => {
    setOpenMobileSearch(!openMobileSearch);
  }, [openMobileSearch, setOpenMobileSearch]);
  const onOpenSearch = useCallback(() => {
    setOpenMobileSearch(true);
  }, [setOpenMobileSearch]);
  return (
    <Fragment>
      <AppBar
        position="fixed"
        color="inherit"
        style={{ boxShadow: "0 13px 21px -9px rgba(0,0,0,.2)" }}
      >
        <Toolbar
          style={{
            backgroundColor: HeaderData?.primaryHeader?.bgColor,
            flexDirection: "column",
          }}
          variant="dense"
        >
          <Box
            display="flex"
            width="100%"
            height={isMobile ? "56px" : "64px"}
            justifyContent="space-between"
            alignItems="center"
          >
            <Box
              width={isMobile ? "40%" : "25%"}
              flexGrow="1"
              display="flex"
              justifyContent="flex-start"
              alignItems="center"
            >
              {(isMobileOnly || isTablet) && (
                <React.Fragment>
                  {history.location.pathname !== "/" && (
                    <Box mr={1}>
                      <IconButton
                        aria-label="delete"
                        size="medium"
                        onClick={HandleGoBack}
                      >
                        <ArrowBackIcon fontSize="inherit" />
                      </IconButton>
                    </Box>
                  )}
                  <Box mx={1}>
                    <IconButton
                      onClick={(e) => {
                        toggleDrawer(e, "menu");
                      }}
                      edge="start"
                      color="inherit"
                      aria-label="menu"
                    >
                      <MenuIcon />
                    </IconButton>
                  </Box>
                </React.Fragment>
              )}
              <Box
                width={isMobile ? "140px" : "calc(100% - 58px)"}
                display="flex"
                maxHeight="60px"
              >
                <Suspense fallback={<Skeleton variant="rect" height="100%" />}>
                  <HeaderLogo HeaderData={HeaderData} />
                </Suspense>
              </Box>
            </Box>
            {!isMobileOnly && (
              <Box width="50%" alignItems="center" display="flex">
                <Box width="80%">
                  <HeaderSearch />
                </Box>
              </Box>
            )}

            <Box
              width="25%"
              alignItems="center"
              display="flex"
              justifyContent="flex-end"
              color={
                HeaderData?.primaryHeader?.iconColor || "rgba(0, 0, 0, 0.54)"
              }
            >
              <Box m={1}>
                <Button
                  variant="outlined"
                  startIcon={<LocationOn />}
                  size="small"
                  disableRipple
                  onClick={() => {
                    setOpenBranchNav(true);
                  }}
                >
                  {!StoreLoading ? (
                 isMobileOnly? <small style={{fontSize:10}}> {data?.name}</small>:data?.name
                  ) : (
                    <Skeleton width="100px" height="100%" />
                  )}
                </Button>
              </Box>
              {isMobileOnly && (
                <IconButton
                  onClick={(e) => {
                    toggleDrawer(e, "search");
                  }}
                >
                  <SearchIcon />
                </IconButton>
              )}
              <Box pr={1}>
                <CartIcon isLoading={isLoading} />
              </Box>
              {!isMobile && (
                <React.Fragment>
                  <Box m={1} />
                  <UserMenu />
                </React.Fragment>
              )}
            </Box>
          </Box>
        </Toolbar>
      </AppBar>
      <Toolbar />
      <SwipeableDrawer
        className={classes.searchDrawer}
        anchor={"right"}
        open={openMobileSearch}
        onClose={CloseSearch}
        onOpen={onOpenSearch}
        width="100%"
      >
        <Box m={1}>
          <HeaderSearch
            setOpenMobileSearch={setOpenMobileSearch}
            openMobileSearch={openMobileSearch}
          />
        </Box>
      </SwipeableDrawer>
      {(isMobileOnly || isTablet) && (
        <NavigationMenu
          HeaderData={HeaderData}
          openMenu={openMenu}
          MENUTYPE={HeaderData?.MEGAMENU?.value}
          setOpenMenu={setOpenMenu}
        />
      )}
      <SwipeableDrawer
        anchor={"right"}
        open={OpenBranchNav}
        onClose={() => {
          setOpenBranchNav(false);
        }}
        onOpen={() => {
          setOpenBranchNav(true);
        }}
      >
        <AppBar position="relative" elevation={0}>
          <Toolbar>
            <Typography variant="h6" className={classes.title}>
              Select Your Store
            </Typography>
            <Box flexGrow={1} />
            <IconButton
              edge="start"
              color="inherit"
              onClick={() => {
                setOpenBranchNav(false);
              }}
              aria-label="close"
            >
              <Close />
            </IconButton>
          </Toolbar>
        </AppBar>
        <Box width="400px" p={2}>
          <BranchAddress
            closeSidenav={() => {
              setOpenBranchNav(false);
            }}
          />
        </Box>
      </SwipeableDrawer>
    </Fragment>
  );
};

export default memo(Header);
